import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5eaa9c8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "musicList"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "musicTop"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " 发现好歌单 "), /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, " 查看更多 ")], -1));
const _hoisted_3 = {
  class: "musicContent"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "playCount"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-play1-copy"
})], -1));
const _hoisted_7 = {
  class: "musicListName"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_swipe, {
    loop: false,
    width: 150,
    class: "my-swiper",
    "show-indicators": false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.musicList, item => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: item
      }, {
        default: _withCtx(() => [_createVNode(_component_router_link, {
          to: {
            path: '/itemmusic',
            query: {
              id: item.id
            }
          }
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: item.picUrl,
            alt: item.name
          }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, [_hoisted_6, _createTextVNode(" " + _toDisplayString($setup.getPlayCount(item.playCount)), 1)]), _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["to"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])]);
}